<template>
    <div class="fs layer0" ref="mc"></div>
</template>

<script>
    import { CreateCameraVideo, TakePhoto, StopVideo } from "@/AR-Renderer/camera_video";
    import { MindArTarget } from "@/AR-Renderer/mind_ar";
    import { GenerateTarget } from "@/AR-Renderer/target_generator";
    import * as AR_Renderer from "@/AR-Renderer/ar_renderer";


    export default {
        name: 'SurfaceScene',
        props: {
            sceneData: Object
        },
        data() {
            return {
            };
        },
        mounted() {
            this.Entry();
        },
        methods: {
            async Entry() {
                this.$parent.ShowLoadingIndicator(true);
                await this.$parent.SetCurrentScene(this);
                this.Launch();
            },

            async Launch() {
                await this.StartVideo();
                this.$parent.ShowLoadingIndicator(false);
                AR_Renderer.onSceneLoaded(this.sceneData.sceneIndex);
                return;
            },

            async ScanSurface() {
                this.$parent.ShowScanningIndicator(true);
                let targetImg = TakePhoto(this.video);
                let targets = await GenerateTarget([targetImg]);
                await this.Setup(targets);
                await this.Start();
                this.$parent.ShowScanningIndicator(false);
                AR_Renderer.onScanningFinished();
            },

            async StartVideo() {
                this.video = await CreateCameraVideo('environment');
                this.$refs.mc.appendChild(this.video);
            },
            async Setup(targets) {
                let amountOfTargets = this.amountOfTargets;
                return await import("mind-ar/dist/mindar-image-three.prod.js").then(async () => {
                    let mindAr = MindArTarget(targets, this.$refs.mc);
                    this.mindAr = mindAr;

                    for (var i = 0; i < this.sceneData.amountOfTargets; i++) {
                        mindAr.addAnchor(i);
                    }

                    let renderer = mindAr.renderer;
                    let scene = mindAr.scene;
                    let camera = mindAr.camera;

                    this.Start = async () => {
                        await mindAr.start();
                        AR_Renderer.onSceneLoaded(this.sceneData.sceneIndex);

                        for (var i = 0; i < this.sceneData.amountOfTarget; i++) {
                            mindAr.anchors[i].group.visible = false;
                        }

                        renderer.setAnimationLoop(() => {
                            this.CheckTarget(mindAr);
                        });

                        return;
                    }

                    this.Stop = async () => {
                        await mindAr.stop();
                        StopVideo(this.video);
                        renderer.setAnimationLoop(null);
                        return;
                    }
                    return;
                });
            },

            CheckTarget(mindAr) {
                let aspect = mindAr.container.offsetWidth / mindAr.container.offsetHeight;

                let cameraFOV = aspect < (4 / 3) ? mindAr.camera.fov : mindAr.camera.fov * (4 / 3) / aspect;

                for (var i = 0; i < this.sceneData.amountOfTargets; i++) {
                    let sceneAnchor = mindAr.anchors[i];
                    if (sceneAnchor.group.visible) {
                        return AR_Renderer.onTargetTracking(sceneAnchor.group.matrix.elements, cameraFOV, i);
                    }
                }

                return AR_Renderer.onTargetTracking(mindAr.camera.matrix.elements, cameraFOV, -1);
            }
        }
    }
</script>

<style scoped>
    @import '../css/styles.css';
</style>
